var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit4SvgrepoCom1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-4-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7864 7.6556L12.4531 4.32227M15.7864 7.6556L11.621 11.8209C11.0721 12.3698 10.4058 12.8032 9.64093 12.9351C8.8686 13.0683 7.91013 13.1127 7.45305 12.6556C6.99597 12.1985 7.04031 11.24 7.17352 10.4677C7.30544 9.70277 7.73881 9.03652 8.28768 8.4876L12.4531 4.32227M15.7864 7.6556C15.7864 7.6556 18.2863 5.1556 16.6197 3.48893C14.953 1.82227 12.4531 4.32227 12.4531 4.32227M17.0827 9.99935C17.0827 15.416 15.416 17.0827 9.99935 17.0827C4.58268 17.0827 2.91602 15.416 2.91602 9.99935C2.91602 4.58268 4.58268 2.91602 9.99935 2.91602",
    stroke: "#666666",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit4SvgrepoCom1);
export default __webpack_public_path__ + "static/media/edit-4-svgrepo-com 1.295c3eb2b83ab17dc1bc56375005547b.svg";
export { ForwardRef as ReactComponent };